import { useQuery } from '@tanstack/react-query'
import { getMeetingGroupOptions } from '../api/minutesApi'

/** Aktif toplantı gruplarını dropdown seçenekleri olarak getirir (039). */
export function useMeetingGroupOptions() {
  return useQuery({
    queryKey: ['minutes-group-options'],
    queryFn: getMeetingGroupOptions,
  })
}
